var render = function () {
  var _vm$selectedApprovedN;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm.$permissionAbility(_vm.BACK_LINK_SHOW, _vm.permissions) ? _c('b-card-actions', {
    attrs: {
      "title": "Filters",
      "action-collapse": ""
    }
  }, [_c('div', [_c('div', [_c('b-row', [_c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "3",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-input', {
    staticClass: "d-inline-block mr-sm-1",
    attrs: {
      "placeholder": "Target/Backlink URL",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "6",
      "lg": "2",
      "xs": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "project",
      "options": _vm.filteredProjectOptions,
      "reduce": function reduce(option) {
        return option.id;
      },
      "label": "name",
      "placeholder": "Select Project"
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.filterSelectProjectId,
      callback: function callback($$v) {
        _vm.filterSelectProjectId = $$v;
      },
      expression: "filterSelectProjectId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "6",
      "lg": "2",
      "xs": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "seller",
      "options": _vm.filteredSellerOptions,
      "reduce": function reduce(option) {
        return option.id;
      },
      "label": "name",
      "placeholder": "Select Seller"
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.filterSelectSellersId,
      callback: function callback($$v) {
        _vm.filterSelectSellersId = $$v;
      },
      expression: "filterSelectSellersId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "6",
      "lg": "2",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.outreachInvoiceStatusConstants,
      "reduce": function reduce(item) {
        return item.value;
      },
      "label": "name",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.filterSelectStatusId,
      callback: function callback($$v) {
        _vm.filterSelectStatusId = $$v;
      },
      expression: "filterSelectStatusId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "6",
      "lg": "2",
      "xs": "12"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Select Published Date Range",
      "config": {
        mode: 'range',
        defaultDate: [_vm.filterPublishStartDate, _vm.filterPublishEndDate]
      }
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.filterPublishedRangeDate,
      callback: function callback($$v) {
        _vm.filterPublishedRangeDate = $$v;
      },
      expression: "filterPublishedRangeDate"
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-between pb-1"
  }, [_vm.$permissionAbility(_vm.BACK_LINK_CREATE, _vm.permissions) ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" Create ")]) : _vm._e()], 1), _vm.$permissionAbility(_vm.BACK_LINK_SHOW, _vm.permissions) ? _c('vue-good-table', {
    attrs: {
      "style-class": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$row2, _props$row2$site_list, _props$row3, _props$row3$site_list, _props$row4, _props$row5, _props$column2, _props$row6, _props$row7, _props$column3, _props$row8, _props$row9, _props$row10, _props$column4, _props$row11, _props$row$site_list, _props$row12, _props$row12$site_lis, _props$column5, _props$row13, _props$row14, _props$row14$seller, _props$column6, _props$row15, _props$row16, _props$row16$project, _props$row16$project$, _props$column7, _props$row17, _props$row18, _props$row18$niche, _props$column8, _props$row19, _props$row20, _props$row20$approvef, _props$column9, _props$row21, _props$row22, _props$row22$currency, _props$row22$currency2, _props$row23, _props$column10, _props$row24, _props$row25, _props$row25$currency, _props$row25$currency2, _props$row26, _props$column11, _props$row27, _props$row28, _props$row28$currency, _props$row28$currency2, _props$row29, _props$row30, _props$column12, _props$row31, _props$row33, _props$row33$invoice, _props$row33$invoice$, _props$column13, _props$row34, _props$row35, _props$row35$invoice, _props$row35$invoice$, _props$row36, _props$row36$invoice, _props$row36$invoice$, _props$row37, _props$row37$invoice, _props$row37$invoice$;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'backlink_url_format' ? [props !== null && props !== void 0 && (_props$row = props.row) !== null && _props$row !== void 0 && _props$row.backlink_url ? _c('div', [_c('div', [_vm._v(" Backlinks: "), _c('a', {
          staticClass: "font-weight-bold",
          attrs: {
            "href": (props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : (_props$row2$site_list = _props$row2.site_list) === null || _props$row2$site_list === void 0 ? void 0 : _props$row2$site_list.website) + '/' + props.row.backlink_url,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatWebsite((props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : (_props$row3$site_list = _props$row3.site_list) === null || _props$row3$site_list === void 0 ? void 0 : _props$row3$site_list.website) + "/" + (props === null || props === void 0 ? void 0 : (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.backlink_url))) + " ")])]), _c('div', [_vm._v(" Target Link: "), _c('a', {
          staticClass: "font-weight-bold",
          attrs: {
            "href": props.row.targeted_url,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatWebsite(props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : _props$row5.targeted_url)) + " ")])])]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'targeted_url_format' ? [props !== null && props !== void 0 && (_props$row6 = props.row) !== null && _props$row6 !== void 0 && _props$row6.targeted_url ? _c('div', [_c('a', {
          staticClass: "font-weight-bold",
          attrs: {
            "href": props.row.targeted_url,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatWebsite(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.targeted_url)) + " ")])]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'backlinks_type_format' ? [props !== null && props !== void 0 && (_props$row8 = props.row) !== null && _props$row8 !== void 0 && _props$row8.backlinks_type ? _c('div', [_c('b-badge', {
          attrs: {
            "variant": _vm.getBacklinkTypeVariant(props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : _props$row9.backlinks_type)
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : _props$row10.backlinks_type_text) + " ")])], 1) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("Exchange")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'website_format' ? [props !== null && props !== void 0 && (_props$row11 = props.row) !== null && _props$row11 !== void 0 && _props$row11.site_list ? _c('div', [_c('a', {
          staticClass: "font-weight-bold",
          attrs: {
            "href": (_props$row$site_list = props.row.site_list) === null || _props$row$site_list === void 0 ? void 0 : _props$row$site_list.website,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatWebsite(props === null || props === void 0 ? void 0 : (_props$row12 = props.row) === null || _props$row12 === void 0 ? void 0 : (_props$row12$site_lis = _props$row12.site_list) === null || _props$row12$site_lis === void 0 ? void 0 : _props$row12$site_lis.website)) + " ")])]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column5 = props.column) === null || _props$column5 === void 0 ? void 0 : _props$column5.field) === 'seller_format' ? [props !== null && props !== void 0 && (_props$row13 = props.row) !== null && _props$row13 !== void 0 && _props$row13.seller ? _c('div', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : (_props$row14$seller = _props$row14.seller) === null || _props$row14$seller === void 0 ? void 0 : _props$row14$seller.name) + " ")]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column6 = props.column) === null || _props$column6 === void 0 ? void 0 : _props$column6.field) === 'project_format' ? [props !== null && props !== void 0 && (_props$row15 = props.row) !== null && _props$row15 !== void 0 && _props$row15.project ? _c('div', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row16 = props.row) === null || _props$row16 === void 0 ? void 0 : (_props$row16$project = _props$row16.project) === null || _props$row16$project === void 0 ? void 0 : (_props$row16$project$ = _props$row16$project.data) === null || _props$row16$project$ === void 0 ? void 0 : _props$row16$project$.title) + " ")]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column7 = props.column) === null || _props$column7 === void 0 ? void 0 : _props$column7.field) === 'niche_format' ? [props !== null && props !== void 0 && (_props$row17 = props.row) !== null && _props$row17 !== void 0 && _props$row17.niche ? _c('div', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : (_props$row18$niche = _props$row18.niche) === null || _props$row18$niche === void 0 ? void 0 : _props$row18$niche.name) + " ")]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column8 = props.column) === null || _props$column8 === void 0 ? void 0 : _props$column8.field) === 'approved_niche' ? [props !== null && props !== void 0 && (_props$row19 = props.row) !== null && _props$row19 !== void 0 && _props$row19.approveforNiches ? _c('div', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row20 = props.row) === null || _props$row20 === void 0 ? void 0 : (_props$row20$approvef = _props$row20.approveforNiches) === null || _props$row20$approvef === void 0 ? void 0 : _props$row20$approvef.name) + " ")]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column9 = props.column) === null || _props$column9 === void 0 ? void 0 : _props$column9.field) === 'cost_price_format' ? [(props === null || props === void 0 ? void 0 : (_props$row21 = props.row) === null || _props$row21 === void 0 ? void 0 : _props$row21.cost_price) != null ? _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-success"
          }
        }, [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row22 = props.row) === null || _props$row22 === void 0 ? void 0 : (_props$row22$currency = _props$row22.currency) === null || _props$row22$currency === void 0 ? void 0 : (_props$row22$currency2 = _props$row22$currency.data) === null || _props$row22$currency2 === void 0 ? void 0 : _props$row22$currency2.currency) + " " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row23 = props.row) === null || _props$row23 === void 0 ? void 0 : _props$row23.cost_price))])], 1) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("Exchange")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column10 = props.column) === null || _props$column10 === void 0 ? void 0 : _props$column10.field) === 'discount_amount_format' ? [(props === null || props === void 0 ? void 0 : (_props$row24 = props.row) === null || _props$row24 === void 0 ? void 0 : _props$row24.discount_amount) > 0 ? _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-danger"
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row25 = props.row) === null || _props$row25 === void 0 ? void 0 : (_props$row25$currency = _props$row25.currency) === null || _props$row25$currency === void 0 ? void 0 : (_props$row25$currency2 = _props$row25$currency.data) === null || _props$row25$currency2 === void 0 ? void 0 : _props$row25$currency2.currency) + " " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row26 = props.row) === null || _props$row26 === void 0 ? void 0 : _props$row26.discount_amount) + " ")])], 1) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("0")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column11 = props.column) === null || _props$column11 === void 0 ? void 0 : _props$column11.field) === 'final_cost_format' ? [(props === null || props === void 0 ? void 0 : (_props$row27 = props.row) === null || _props$row27 === void 0 ? void 0 : _props$row27.cost_price) != null ? _c('div', [_c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row28 = props.row) === null || _props$row28 === void 0 ? void 0 : (_props$row28$currency = _props$row28.currency) === null || _props$row28$currency === void 0 ? void 0 : (_props$row28$currency2 = _props$row28$currency.data) === null || _props$row28$currency2 === void 0 ? void 0 : _props$row28$currency2.currency) + " " + _vm._s((parseFloat((props === null || props === void 0 ? void 0 : (_props$row29 = props.row) === null || _props$row29 === void 0 ? void 0 : _props$row29.cost_price) || 0) - parseFloat((props === null || props === void 0 ? void 0 : (_props$row30 = props.row) === null || _props$row30 === void 0 ? void 0 : _props$row30.discount_amount) || 0)).toFixed(2)) + " ")])], 1) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("Exchange")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column12 = props.column) === null || _props$column12 === void 0 ? void 0 : _props$column12.field) === 'format_invoice_number' ? [props !== null && props !== void 0 && (_props$row31 = props.row) !== null && _props$row31 !== void 0 && _props$row31.invoice ? _c('div', [_c('b-badge', {
          staticClass: "cursor-pointer badge-link no-wrap",
          attrs: {
            "variant": "light-primary"
          },
          on: {
            "click": function click($event) {
              var _props$row32, _props$row32$invoice, _props$row32$invoice$;
              return _vm.onShowDetails(props === null || props === void 0 ? void 0 : (_props$row32 = props.row) === null || _props$row32 === void 0 ? void 0 : (_props$row32$invoice = _props$row32.invoice) === null || _props$row32$invoice === void 0 ? void 0 : (_props$row32$invoice$ = _props$row32$invoice.data) === null || _props$row32$invoice$ === void 0 ? void 0 : _props$row32$invoice$.id);
            }
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row33 = props.row) === null || _props$row33 === void 0 ? void 0 : (_props$row33$invoice = _props$row33.invoice) === null || _props$row33$invoice === void 0 ? void 0 : (_props$row33$invoice$ = _props$row33$invoice.data) === null || _props$row33$invoice$ === void 0 ? void 0 : _props$row33$invoice$.invoice_number) + " ")])], 1) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column13 = props.column) === null || _props$column13 === void 0 ? void 0 : _props$column13.field) === 'status_format' ? [props !== null && props !== void 0 && (_props$row34 = props.row) !== null && _props$row34 !== void 0 && _props$row34.outreach_invoice_id ? _c('b-badge', {
          attrs: {
            "variant": (props === null || props === void 0 ? void 0 : (_props$row35 = props.row) === null || _props$row35 === void 0 ? void 0 : (_props$row35$invoice = _props$row35.invoice) === null || _props$row35$invoice === void 0 ? void 0 : (_props$row35$invoice$ = _props$row35$invoice.data) === null || _props$row35$invoice$ === void 0 ? void 0 : _props$row35$invoice$.status) === _vm.paymentDueConstants ? 'light-warning' : (props === null || props === void 0 ? void 0 : (_props$row36 = props.row) === null || _props$row36 === void 0 ? void 0 : (_props$row36$invoice = _props$row36.invoice) === null || _props$row36$invoice === void 0 ? void 0 : (_props$row36$invoice$ = _props$row36$invoice.data) === null || _props$row36$invoice$ === void 0 ? void 0 : _props$row36$invoice$.status) === _vm.paymentPaidConstants ? 'light-success' : 'light-secondary'
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row37 = props.row) === null || _props$row37 === void 0 ? void 0 : (_props$row37$invoice = _props$row37.invoice) === null || _props$row37$invoice === void 0 ? void 0 : (_props$row37$invoice$ = _props$row37$invoice.data) === null || _props$row37$invoice$ === void 0 ? void 0 : _props$row37$invoice$.status_text) + " ")]) : _c('b-badge', {
          attrs: {
            "variant": "light-secondary"
          }
        }, [_vm._v(" Pending ")])] : _vm._e(), props.column.field === 'action' ? _c('span', [_vm.$permissionAbility(_vm.BACK_LINK_ADMIN_EDIT_BEFORE_AND_AFTER_PAYMENT, _vm.permissions) && _vm.$permissionAbility(_vm.BACK_LINK_EDIT, _vm.permissions) || !props.row.outreach_invoice_id && _vm.$permissionAbility(_vm.BACK_LINK_EDIT, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "Edit2Icon",
            "title": "Edit",
            "size": "16"
          }
        })], 1)] : _vm._e(), !props.row.outreach_invoice_id && _vm.$permissionAbility(_vm.BACK_LINK_DELETE, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "TrashIcon",
            "title": "Delete",
            "size": "16"
          }
        })], 1)] : _vm._e()], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }], null, false, 1458644431)
  }) : _vm._e(), _vm.totalCostData.length > 0 ? _c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Total Cost")]), _c('div', {
    staticClass: "d-inline-flex px-3"
  }, _vm._l(_vm.totalCostData, function (data, index) {
    var _data$currency;
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-column align-items-center px-5 py-1",
      style: {
        borderRight: index !== _vm.totalCostData.length - 1 ? '1px solid #ccc' : 'none'
      }
    }, [_c('h6', {
      staticClass: "mb-1",
      class: {
        'text-primary': index % 5 === 0,
        'text-success': index % 5 === 1,
        // Apply text-success for index 1, 6, 11, etc.
        'text-warning': index % 5 === 2,
        // Apply text-warning for index 2, 7, 12, etc.
        'text-info': index % 5 === 3,
        // Apply text-info for index 3, 8, 13, etc.
        'text-secondary': index % 5 === 4 // Apply text-secondary for index 4, 9, 14, etc.
      },
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "600"
      }
    }, [_vm._v(" " + _vm._s(data === null || data === void 0 ? void 0 : (_data$currency = data.currency) === null || _data$currency === void 0 ? void 0 : _data$currency.currency) + " ")]), _c('h5', {
      class: {
        'text-primary': index % 5 === 0,
        'text-success': index % 5 === 1,
        // Apply text-success for index 1, 6, 11, etc.
        'text-warning': index % 5 === 2,
        // Apply text-warning for index 2, 7, 12, etc.
        'text-info': index % 5 === 3,
        // Apply text-info for index 3, 8, 13, etc.
        'text-secondary': index % 5 === 4 // Apply text-secondary for index 4, 9, 14, etc.
      },
      staticStyle: {
        "font-size": "1.5rem",
        "font-weight": "700"
      }
    }, [_vm._v(" " + _vm._s(data === null || data === void 0 ? void 0 : data.total_cost_price) + " ")])]);
  }), 0)]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "modal-create-form",
      "centered": "",
      "title": _vm.modelType === 'editModel' ? 'Edit Backlinks' : 'Create Backlinks',
      "hide-footer": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "createFormValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Website",
      "label-for": "website"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "website",
      "vid": "website",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "id": "website",
            "options": _vm.filteredSiteListOptions,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "website_with_niche",
            "placeholder": "Choose Here"
          },
          on: {
            "input": _vm.filteredApproved
          },
          model: {
            value: _vm.selectSiteListId,
            callback: function callback($$v) {
              _vm.selectSiteListId = $$v;
            },
            expression: "selectSiteListId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Approved For",
      "label-for": "approved_for"
    }
  }, [_c('validation-provider', {
    staticClass: "required-label",
    attrs: {
      "name": "approved for",
      "vid": "approved_for",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          attrs: {
            "id": "approved_for",
            "options": _vm.filteredApprovedNicheOptions,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name",
            "placeholder": "Choose Here",
            "rules": "required"
          },
          on: {
            "input": _vm.selectApprovedFor
          },
          model: {
            value: _vm.approvedForId,
            callback: function callback($$v) {
              _vm.approvedForId = $$v;
            },
            expression: "approvedForId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), !((_vm$selectedApprovedN = _vm.selectedApprovedNiche) !== null && _vm$selectedApprovedN !== void 0 && _vm$selectedApprovedN.exchange) ? [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Backlinks Type",
      "label-for": "backlinks_type"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "backlinks type",
      "vid": "backlinks_type",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('v-select', {
          attrs: {
            "id": "backlinks_type",
            "options": _vm.backLinkTypeOptions,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "name",
            "placeholder": "Choose Here",
            "disabled": !_vm.approvedForId
          },
          on: {
            "input": _vm.calculateCost
          },
          model: {
            value: _vm.selectBacklinksTypeId,
            callback: function callback($$v) {
              _vm.selectBacklinksTypeId = $$v;
            },
            expression: "selectBacklinksTypeId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1386504494)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Currency",
      "label-for": "cost_price"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "currency",
      "options": _vm.filteredCurrencyOptions,
      "reduce": function reduce(option) {
        return option.id;
      },
      "label": "name",
      "placeholder": "",
      "disabled": "",
      "clearable": false
    },
    model: {
      value: _vm.selectedCurrency,
      callback: function callback($$v) {
        _vm.selectedCurrency = $$v;
      },
      expression: "selectedCurrency"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Price",
      "label-for": "cost_price"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "cost_price",
      "vid": "cost_price"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "cost_price",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Cost Price",
            "disabled": ""
          },
          model: {
            value: _vm.costPriceInput,
            callback: function callback($$v) {
              _vm.costPriceInput = $$v;
            },
            expression: "costPriceInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1804939160)
  })], 1)], 1)], 1)], 1)] : _vm._e(), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Backlinks",
      "label-for": "backlink_url"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "backlinks",
      "vid": "backlink_url",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "6"
          }
        }, [_c('v-select', {
          attrs: {
            "id": "website",
            "options": _vm.filteredSiteListOptions,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "website",
            "placeholder": "",
            "disabled": ""
          },
          on: {
            "input": _vm.filteredApproved
          },
          model: {
            value: _vm.selectSiteListId,
            callback: function callback($$v) {
              _vm.selectSiteListId = $$v;
            },
            expression: "selectSiteListId"
          }
        })], 1), _c('b-col', {
          attrs: {
            "cols": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "backlink_url",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Path of url without domain"
          },
          model: {
            value: _vm.backLinkUrlInput,
            callback: function callback($$v) {
              _vm.backLinkUrlInput = $$v;
            },
            expression: "backLinkUrlInput"
          }
        })], 1)], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Targeted Link",
      "label-for": "targeted_url"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Targeted Link",
      "vid": "targeted_url",
      "rules": "required|url"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "targeted_url",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "The website must be a valid URL. (e.g https://www.example.com)"
          },
          model: {
            value: _vm.targetedUrlInput,
            callback: function callback($$v) {
              _vm.targetedUrlInput = $$v;
            },
            expression: "targetedUrlInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Project",
      "label-for": "project"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "project",
      "vid": "project",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('v-select', {
          attrs: {
            "id": "project",
            "options": _vm.filteredProjectOptions,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name",
            "placeholder": "Choose Here"
          },
          model: {
            value: _vm.selectProjectId,
            callback: function callback($$v) {
              _vm.selectProjectId = $$v;
            },
            expression: "selectProjectId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remarks",
      "label-for": "remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.remarksInput,
            callback: function callback($$v) {
              _vm.remarksInput = $$v;
            },
            expression: "remarksInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 2), _vm.isSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-create-invoice-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Invoice' : 'Create Invoice',
      "hide-footer": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenInvoiceModal
    }
  }, [_c('validation-observer', {
    ref: "createInvoiceFormValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationInvoiceForm($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Invoice Date",
      "label-for": "invoice_date"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "invoice_date",
      "vid": "invoice_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-datepicker', {
          staticClass: "form-control custom-font",
          attrs: {
            "id": "invoice_date",
            "state": errors.length > 0 ? false : null,
            "locale": "en-US",
            "today-button": "",
            "close-button": "",
            "reset-button": "",
            "placeholder": "Invoice Date"
          },
          model: {
            value: _vm.invoiceDateInput,
            callback: function callback($$v) {
              _vm.invoiceDateInput = $$v;
            },
            expression: "invoiceDateInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Payment Method",
      "label-for": "payment_method"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "payment_method",
      "vid": "payment_method",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var errors = _ref10.errors;
        return [_c('v-select', {
          attrs: {
            "id": "payment_method",
            "options": _vm.filteredPaymentOptions,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name",
            "placeholder": "Choose Here"
          },
          model: {
            value: _vm.selectPaymentId,
            callback: function callback($$v) {
              _vm.selectPaymentId = $$v;
            },
            expression: "selectPaymentId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Payment Date",
      "label-for": "payment_date"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "payment_date",
      "vid": "payment_date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref11) {
        var errors = _ref11.errors;
        return [_c('b-form-datepicker', {
          staticClass: "form-control custom-font",
          attrs: {
            "id": "payment_date",
            "state": errors.length > 0 ? false : null,
            "locale": "en-US",
            "today-button": "",
            "close-button": "",
            "reset-button": "",
            "placeholder": "Payment Date"
          },
          model: {
            value: _vm.paymentDateInput,
            callback: function callback($$v) {
              _vm.paymentDateInput = $$v;
            },
            expression: "paymentDateInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Approver",
      "label-for": "approver_id"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Approver",
      "vid": "approver_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref12) {
        var errors = _ref12.errors;
        return [_c('v-select', {
          attrs: {
            "id": "approver_id",
            "options": _vm.filteredApproverOptions,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name",
            "placeholder": "Choose Here"
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.selectApproverId,
            callback: function callback($$v) {
              _vm.selectApproverId = $$v;
            },
            expression: "selectApproverId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Payment Details",
      "label-for": "payment_details"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Payment Details",
      "vid": "payment_details"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref13) {
        var errors = _ref13.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "payment_details",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Payment Details",
            "rows": "3"
          },
          model: {
            value: _vm.paymentDetailsInput,
            callback: function callback($$v) {
              _vm.paymentDetailsInput = $$v;
            },
            expression: "paymentDetailsInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remarks",
      "label-for": "remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Remarks",
      "vid": "remarks"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref14) {
        var errors = _ref14.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.remarksInput,
            callback: function callback($$v) {
              _vm.remarksInput = $$v;
            },
            expression: "remarksInput"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _vm.isSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }